import { ref, computed, onMounted } from "vue";
import { defineStore } from "pinia";
import { useRoute } from "vue-router";
import axios from "axios";
import { API_URL } from "@/utils/constans.js";

export const useSettingsStore = defineStore("settings", () => {
	const isClient = typeof window !== "undefined";

	const route = useRoute();
	const settings = ref({});

	const widthWindow = ref(null);
	const heightWindow = ref(null);
	if (isClient) {
		widthWindow.value = window.innerWidth;
		heightWindow.value = window.innerHeight;
	}

	const statusStockActive = computed(() => settings.value?.status === "active"); // активный
	const statusStockFuture = computed(() => settings.value?.status === "future"); // еще не начался
	const statusStockPast = computed(() => settings.value?.status === "past"); // прошел
	const startDate = computed(() => settings.value?.start_date);
	const endDate = computed(() => settings.value?.end_date);
	const counterTicketsGrand = computed(() => settings.value?.grand_draw_participants_count);
	const activeEvent = computed(() => settings.value?.event || null);
	const isTelegramPage = computed(() => route.name.includes("telegram"));
	const loaderActive = ref(false);
	const isPageLoaded = ref(false);
	const scrollY = ref(0);
	const referralCode = ref(null);
	const tgUrl = "https://telegram.me/greenfieldworld_bot";
	// const tgUrl = "https://t.me/greenfieldworld_bot";
	const mobileMenuOpen = ref(false);

	const closeMobileMenu = () => {
		mobileMenuOpen.value = false;
		if (isClient) {
			document.body.classList.remove("noscroll");
		}
	};

	const mainSettings = async () => {
		try {
			const response = await axios.get(`${API_URL}/api/main/settings`);
			settings.value = response.data;
		} catch (error) {
			console.log("error:", error);
		}
	};

	const getFaq = async () => {
		try {
			let url = `${API_URL}/api/feedback/faq`;
			let allResults = [];

			while (url) {
				const { data } = await axios.get(url);
				allResults = [...allResults, ...data.results];
				url = data.next;
			}

			return allResults;
		} catch (error) {
			console.log("getFaq:", error);
		}
	};

	const updateWidthWindow = () => {
		widthWindow.value = window.innerWidth;
		heightWindow.value = window.innerHeight;
	};

	const pageLoaded = () => {
		setTimeout(() => (isPageLoaded.value = true), 1000);
	};
	
	const setReferralCode = (refFromQuery) => {
		if (!isClient) return;

		if (refFromQuery) {
			referralCode.value = refFromQuery;
		} else {
			referralCode.value = localStorage.getItem("ref");
		}
	};
	const telegramUrl = computed(() => (referralCode.value ? `${tgUrl}?referral_code=${referralCode.value}` : tgUrl));

	// onMounted( () => {
	// window.addEventListener("resize", updateWidthWindow);
	// if (document.readyState === "complete") {
	// 	pageLoaded();
	// } else {
	// 	window.onload = () => pageLoaded();
	// }
	// referralCode.value = localStorage.getItem("ref")
	// });

	return {
		mainSettings,
		getFaq,
		updateWidthWindow,
		pageLoaded,
		setReferralCode,
		closeMobileMenu,

		settings,
		loaderActive,
		isPageLoaded,
		widthWindow,
		heightWindow,
		statusStockActive,
		statusStockFuture,
		statusStockPast,
		scrollY,
		startDate,
		endDate,
		telegramUrl,
		referralCode,
		counterTicketsGrand,
		activeEvent,
		isTelegramPage,
		tgUrl,
		mobileMenuOpen,
	};
});
